import {FilesAction} from '@/store/files/files.actions';
import {Files, FilesInitState} from '@/store/files/files.types';
import {FilesMutations} from '@/store/files/files.mutations';

const namespaced = true;

export const filesInitState: FilesInitState = {
    files: [{}] as Files[],
    profile: [{}] as Files[],
};

export const filesState = {
    namespaced,
    state: filesInitState,
    actions: FilesAction,
    mutations: FilesMutations,
    // getters
};
